export default __webpack_public_path__ + "static/media/brand_id_11.77996ff7.jpg";